<template>
  <div class="map__wrapper">
    <div class="map__header" v-if="mapHeader">
      <div class="wrapper">
        <span class="header__title">{{ headerTitle }}</span>
        <span class="header__description" v-html="headerDescription"></span>
      </div>
    </div>

    <div id="map"></div>

    <div class="map__legend" v-if="mapLegend">
      <div class="wrapper">
        <span class="legend-label">Légende :</span>
        <ul class="legend-list">
          <li class="legend-list-item" v-for="legend in legends">
            <img width="32" height="37" :src="legend.icon" :title="legend.name" :alt="`Icône ${legend.name}`" class="attachment-80x60">
            <span class="legend-list-text">{{ legend.name }}</span>
           </li>
        </ul>
      </div>
    </div>
    <button @click="proximityClick" class="btn-map">
      <svg class="icon icon-map" aria-hidden="true" role="img">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-map"></use>
      </svg>
      A proximité
    </button>
  </div>
</template>

<script>
  /* global L */
  /* global dataLayer */
  /* global cgy_vars */
  /* eslint no-undef: "error" */

  import store from '../store/store'
  import json from '../store/jsonUrl'
  import _ from 'lodash'
  import omnivore from '@mapbox/leaflet-omnivore'

  export default {
    name: 'maps',
    data () {
      return {
        places: [],
        info: '',
        panel: '',
        mapHeader: false,
        mapLegend: false,
        headerTitle: '',
        headerDescription: '',
        catInfos: [],
        legends: [],
        iconUrl: cgy_vars.defaultMarker,
        showSidebar: cgy_vars.showSidebar || false,
        mapRender: cgy_vars.map_style || false
      }
    },
    mounted () {
      let lat = cgy_vars.map_center.split(',')[0]
      let lng = cgy_vars.map_center.split(',')[1]
      let zoom = cgy_vars.map_zoom
      store.state.map = L.map('map', {attributionControl: false}).setView([lat, lng], zoom)
      this.defaultMapRender(this.mapRender)
      store.state.map.zoomControl.setPosition('bottomright')

      if (cgy_vars.cluster.cluster) {
        store.cache.markersGroup = L.markerClusterGroup({
          disableClusteringAtZoom: cgy_vars.cluster.cluster_zoom,
          maxClusterRadius: cgy_vars.cluster.cluster_size
        })
      } else {
        store.cache.markersGroup = L.featureGroup()
      }

      for (var i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$options.name === 'place-info') {
          this.info = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'panel') {
          this.panel = this.$parent.$children[i]
        }
      }
      // Get default places to display
      this.getDefaultCats().then((places) => {
        places.forEach(function (place) {
          this.places.push(place)
        }, this)
      }).then(_ => {
        this.createDefaultPlacesMarker()
      })

      // Get params url
      this.trimParams()
    },
    methods: {
      getDefaultCats: function () {
        let promises = []

        if (!_.isEmpty(cgy_vars.default_cats)) {
          promises = cgy_vars.default_cats.map(cat => {
            return this.$http.get(`${json.url.category}&id=${cat}`)
          })
        }
        promises.push(this.$http.get(json.url.list))

        return Promise.all(promises)
          .then(responses => {
            return responses.map(response => response.data.filter(item => item.display === true))
          })
          .then(cats => cats.reduce((final, current) => {
            final = [...final, ...current]
            return final
          }, []))
          // .then(cats => cats.reduce((current, value) => { current = [...current, ...value] }, []))
      },
      defaultMapRender: function (type) {
        if (store.cache.render) {
          store.state.map.removeLayer(store.cache.render)
        }

        if (type === 'plan') {
          dataLayer.push({rendu: 'Plan'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'satellite') {
          dataLayer.push({rendu: 'Satellite'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'relief') {
          dataLayer.push({rendu: 'Relief'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'mixte') {
          dataLayer.push({rendu: 'Mixte'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else {
          return false
        }
        store.state.map.addLayer(store.cache.render)
      },
      createDefaultPlacesMarker: function () {
        this.places.forEach(function (place) {
          // create custom icon
          let markerIcon
          if (place.icon) {
            markerIcon = store.iconOptions({
              options: {
                iconUrl: place.icon
              }
            })
          } else {
            markerIcon = L.icon({
              iconUrl: this.iconUrl,
              iconSize: [21, 26],
              iconAnchor: [10.5, 26]
            })
          }
          // create marker object, pass custom icon as option, add to map
          let marker = L.marker([place.lat, place.lng], {icon: markerIcon, placeId: place.id}).on('click', this.info.markerOnClick)
          this.markerPopup(marker, place.name)
          marker.placeId = place.id
          store.cache.markersGroup.addLayer(marker)
        }, this)
        store.state.map.addLayer(store.cache.markersGroup)
      },
      markerPopup: function (marker, name) {
        marker.bindPopup(name, {offset: new L.Point(0, -28)})
        marker.on('mouseover', function (e) {
          this.openPopup()
        })
        marker.on('mouseout', function (e) {
          this.closePopup()
        })
      },
      trimParams: function () {
        let params
        let type
        let id
        if (window.location.search) {
          params = window.location.search.substring(1)
          params = params.split('&')[0]
          type = params.split('=')[0]
          id = params.split('=')[1]
        } else if (window.location.hash) {
          params = window.location.hash.substring(1)
          type = params.split('-')[0]
          id = params.split('-')[1]
        } else {
          return false
        }
        this.directLinkReq(type, id)
        store.state.isEmbed = true
        this.handleEmbedTask()
      },
      handleEmbedTask: function () {
        if (store.state.isEmbed) {
          document.getElementById('app').classList.add('isEmbed')
          if (this.showSidebar === '1') {
            document.getElementById('app').classList.add('showSidebar')
          }
        }
      },
      directLinkReq: function (type, id) {
        if (type === 'place') {
          this.doPlaceReq(id)
        } else if (type === 'map') {
          this.mapHeader = true
          this.doMapReq(id)
        } else if (type === 'cat') {
          this.mapHeader = true
          this.doCatReq(id)
        } else {
          return false
        }
      },
      doPlaceReq: function (id) {
        if (store.cache.places[id] && store.cache.activate) {
          this.panel.displaySingleMarkerOnMap(id, store.cache.places[id].name, store.cache.places[id].icon, store.cache.places[id].lat, store.cache.places[id].lng)
          this.injectSchemaScript(store.cache.places[id])
        } else {
          this.$http.get(`${json.url.place}&id=${id}`).then((response) => {
            this.panel.displaySingleMarkerOnMap(id, response.data.name, response.data.icon, response.data.lat, response.data.lng)
            this.injectSchemaScript(response.data)
            store.cache.places[id] = response.data
          }, (response) => {
            console.log('error', response)
          })
        }
      },
      injectSchemaScript: function (place) {
        this.$http.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${place.lat}&lon=${place.lng}`).then((response) => {
          const div = document.createElement('script')
          div.type = 'application/ld+json'
          const jsonData = {
            '@context': 'http://schema.org',
            '@type': 'Place',
            'address': {
              '@type': 'PostalAddress',
              'streetAddress': response.body.address.road,
              'addressLocality': response.body.address.town,
              'postalCode': response.body.address.postcode
            },
            'name': place.name
          }
          div.innerHTML = JSON.stringify(jsonData)
          document.body.appendChild(div)
        })
      },
      doCatReq: function (id) {
        if (store.cache.category[id] && store.cache.activate) {
          this.places = store.cache.category[id]
          this.displayAllMarkerOnMap(this.places)
        } else {
          this.$http.get(`${json.url.category}&id=${id}`).then((response) => {
            this.places = response.data
            store.cache.category[id] = response.data
            this.displayAllMarkerOnMap(this.places)
          }, (response) => {
            console.log('error', response)
          })
        }

        if (store.cache.category_infos[id] && store.cache.activate) {
          this.catInfos = store.cache.category_infos[id]
          this.headerTitle = this.catInfos.name
          this.headerDescription = this.catInfos.description
        } else {
          this.$http.get(`${json.url.category_infos}&id=${id}`).then((response) => {
            this.catInfos = response.data
            store.cache.category_infos[id] = response.data
          }, (response) => {
            console.log('error', response)
          }).then(_ => {
            this.headerTitle = this.catInfos.name
            this.headerDescription = this.catInfos.description
          })
        }
      },
      doMapReq: function (id) {
        if (store.cache.map[id] && store.cache.activate) {
          this.places = store.cache.map[id]
          this.displayAllMarkerOnMap(this.places)
        } else {
          this.$http.get(`${json.url.map}&id=${id}`).then((response) => {
            store.cache.map[id] = response.data
            this.places = store.cache.map[id]
            this.displayAllMarkerOnMap(this.places)
          }, (response) => {
            console.log('error', response)
          }).then(_ => {
            this.getMapInfo(id)
          })
        }
      },
      getMapInfo: function (id) {
        if (store.cache.mapUrl[id] && store.cache.activate) {
          this.setupMapInfo(store.cache.mapUrl[id][0])
        } else {
          this.$http.get(`${json.url.mapUrl}&id=${id}`).then((response) => {
            store.cache.mapUrl[id] = response.data
            return store.cache
          }).then(cache => {
            this.setupMapInfo(cache.mapUrl[id][0])
          }).catch(err => console.log(err))
        }
      },
      setupMapInfo: function (map) {
        this.headerTitle = map.name
        this.headerDescription = map.description
        if (map.url) {
          this.displayKML(map)
        }
        if (map.legend) {
          this.displayLegend(map)
        }
      },
      displayKML: function (map) {
        let customLayer = L.geoJson(null, {
          style: function (feature) {
            return {
              color: cgy_vars.line.strokeColor
            }
          }
        }, this)
        let layer = omnivore.kml(map.url, null, customLayer)
        store.state.map.addLayer(layer)
        layer.on('ready', function () {
          store.state.map.fitBounds(layer.getBounds())
        }, this)
      },
      displayLegend: function (map) {
        this.mapLegend = true
        store.cache.map[map.id].forEach(function (res) {
          if (!_.find(this.legends, {name: res.name_cat})) {
            let obj = {}
            obj.name = res.name_cat
            obj.icon = res.placeIcon
            this.legends.push(obj)
          }
        }, this)
      },
      displayAllMarkerOnMap: function (places) {
        // Clear markers
        store.cache.markersGroup.clearLayers()
        if (places.length === 0) {
          return
        }
        for (let i = 0; i < places.length; i++) {
          if (!this.checkIsValidPlace(places[i])) {
            continue
          }
          // create custom icon
          let markerIcon
          if (places[i].icon) {
            markerIcon = store.iconOptions({
              options: {
                iconUrl: places[i].icon
              }
            })
          } else {
            markerIcon = L.icon({
              iconUrl: this.iconUrl,
              iconSize: [21, 26],
              iconAnchor: [10.5, 26]
            })
          }

          // create marker object, pass custom icon as option, add to map
          let marker = L.marker([places[i].lat, places[i].lng], {icon: markerIcon}).on('click', this.info.markerOnClick)
          marker.placeId = places[i].id
          store.cache.markersGroup.addLayer(marker)
        }
        store.state.map.fitBounds(store.cache.markersGroup.getBounds())
        store.state.map.addLayer(store.cache.markersGroup)
      },
      checkIsValidPlace: function (place) {
        return (_.isNumber(+place.lat) && _.isNumber(+place.lng)) && (!_.isNaN(+place.lat) && !_.isNaN(+place.lng) && (place.lat && place.lng))
      },
      proximityClick: function () {
        this.panel.proximityClick()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Maps.vue?8bcd77c0